import { Draggable } from "react-beautiful-dnd";
import styled from "styled-components";
import ReactTooltip from "react-tooltip";

const TestItemContainer = styled.div`
  background-color: #efefef;
  display: inline-block;
  overflow: hidden;
  width: 60px;
  height: 60px;
`;

function TestItem(props) {
  const { item, itemMap, index } = props;
  return (
    itemMap[item] && (
      <Draggable
        draggableId={itemMap[item].id}
        key={itemMap[item].id}
        index={index}
      >
        {(provided, snapshot) => (
          <>
            <TestItemContainer
              ref={provided.innerRef}
              {...provided.draggableProps}
              {...provided.dragHandleProps}
              backgroundImage={itemMap[item].imageUrl}
              data-tip
              data-for={item}
            >
              <ReactTooltip id={item} place="top" type="dark" effect="float">
                <span>{itemMap[item].altText}</span>
              </ReactTooltip>
              {itemMap[item].imageUrl ? (
                <img
                  src={itemMap[item].imageUrl}
                  alt={itemMap[item].altText}
                  style={{ width: "100%" }}
                />
              ) : (
                itemMap[item].altText
              )}
            </TestItemContainer>
          </>
        )}
      </Draggable>
    )
  );
}
export default TestItem;
